/* eslint-disable no-underscore-dangle */
import { RestRequest } from '../public/utils/rest';

const envVar = (typeof window._env_ !== 'undefined') ? window._env_ : process.env;

// Aliash for prepareQueryParams
const p = RestRequest.prepareUrlParams;

// const loginEndpoint = 'https://login.systemxlite.com/api/loginserver';
// const loginEndpoint = 'https://test.systemxlite.com/api/loginserver';
const loginEndpoint = envVar.REACT_APP_LOGINENDPOINT;
const npstocksLoginEndpoint = envVar.REACT_APP_NPSTOCKS_LOGINENDPOINT;
// const loginEndpoint = 'http://localhost:9001';

// const mainEndpoint = 'https://login.systemxlite.com/api/mainserver';
// const mainEndpoint = 'https://test.systemxlite.com/api/mainserver';
const mainEndpoint = envVar.REACT_APP_MAINENDPOINT;
// const mainEndpoint = 'http://localhost:9000';

const technicalChartFrontendEndpoint = envVar.REACT_APP_TRADINGVIEW_FRONTEND_URL;
// export const referralLink = 'https://login.systemxlite.com';
// export const referralLink = 'https://test.systemxlite.com';
export const referralLink = envVar.REACT_APP_REFERRALLINK;
// export const referralLink = 'http://localhost:4000';

export const dalalStreetBaseUrl = envVar.REACT_APP_DALALSTREET_BACKEND_URL;

const POST = 'POST'; // eslint-disable-line
const GET = 'GET'; // eslint-disable-line
const PUT = 'PUT'; // eslint-disable-line
const DELETE = 'DELETE'; // eslint-disable-line
const PATCH = 'PATCH'; // eslint-disable-line

const commonHeaderForPost = {
    'Content-Type': 'application/json',
};

export const paramsForGET = () => ({
    // credentials: 'include',
    method: GET,
});

export const paramsForGet = ({ token }) => ({
    method: GET,
    headers: {
        Authorization: token ? `Bearer ${token}` : '',
    },
});

// Rest for Login

export const urlForLogin = `${npstocksLoginEndpoint}/npstocks/v2/login`;
export const urlForLogout = `${npstocksLoginEndpoint}/npstocks/v2/logout/web`;

export const createParamsForLogin = ({ username, password }) => ({
    method: POST,
    headers: commonHeaderForPost,
    body: JSON.stringify({
        username,
        password,
        platform: 'web',
    }),
});

export const urlForRegister = `${npstocksLoginEndpoint}/npstocks/v2/register`;

// eslint-disable-next-line max-len
export const createParamsForRegister = ({ firstname, lastname, username, phoneNumber, vendor }) => ({
    method: POST,
    headers: commonHeaderForPost,
    body: JSON.stringify({
        firstname,
        lastname,
        username,
        phoneNumber,
        vendor,
    }),
});

export const urlForPasswordReset = `${npstocksLoginEndpoint}/npstocks/v2/password-reset-code`;
export const createParamsForPasswordReset = ({ username }) => ({
    method: POST,
    headers: commonHeaderForPost,
    body: JSON.stringify({ username }),
});

export const urlForPasswordResetPin = `${npstocksLoginEndpoint}/npstocks/v2/validate-password-reset-code`;
export const createParamsForPasswordResetPin = ({ username, passwordResetCode }) => ({
    method: POST,
    headers: commonHeaderForPost,
    body: JSON.stringify({ username, passwordResetCode }),
});

export const urlForForgotPasswordReset = `${npstocksLoginEndpoint}/npstocks/v2/reset-password`;
export const createParamsForForgotPasswordReset = ({
    username,
    passwordResetCode,
    newPassword,
}) => ({
    method: POST,
    headers: commonHeaderForPost,
    body: JSON.stringify({
        username,
        passwordResetCode,
        newPassword,
    }),
});

export const urlForTokenSync = `${loginEndpoint}/systemxLt/tokenSync`;

export const urlForChangePassword = `${npstocksLoginEndpoint}/npstocks/v2/changePassword`;
export const createParamsForChangePassword = ({ token, oldPassword, newPassword }) => ({
    method: POST,
    headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({
        oldPassword,
        newPassword,
    }),
});

// Rest for user info
export const urlForUserInfo = `${loginEndpoint}/systemxlt/userInfo`;

// Rest for payment
export const urlForUserPaymentScheme = `${npstocksLoginEndpoint}/npstocks/esewa-payment/scheme`;
export const urlForUserPaymentEsewaTicket = `${npstocksLoginEndpoint}/npstocks/esewa-payment/ticket`;
export const urlForUserPaymentEsewaConfirmation = `${npstocksLoginEndpoint}/npstocks/esewa-payment/paymentConfirmation`;
export const urlForUserEsewaLog = `${npstocksLoginEndpoint}/npstocks/esewa-payment/track-log`;

export const createParamsForUserPaymentEsewaTicket = ({ token, userId, schemeId }) => ({
    method: POST,
    headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({
        userId,
        schemeId,
    }),
});

export const createParamsForUserPaymentEsewaConfirmation = ({ token, oid, amt, refId }) => ({
    method: POST,
    headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({
        oid,
        amt,
        refId,
    }),
});

export const createParamsForEsewaPaymentLog = ({ token, oid, amt, refId, message }) => ({
    method: POST,
    headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({
        oid,
        amt,
        refId,
        message,
    }),
});
// Rest for Ticker Detail

export const urlForTickersDetail = `${mainEndpoint}/tickers`;
export const urlForSelectedTickerDetail = ticker => `${mainEndpoint}/tickers/${ticker.toLowerCase()}`;

// Rest for Announcement
const urlForAnnouncement = `${mainEndpoint}/announcement`;

export const urlForAnnouncementNepseCircular = `${urlForAnnouncement}/nepse-circular`;
export const urlForAnnouncementFinancials = `${urlForAnnouncement}/financials`;
export const urlForAnnouncementIpoFpo = `${urlForAnnouncement}/ipo-fpo`;
export const urlForAnnouncementRightShares = `${urlForAnnouncement}/right-shares`;
export const urlForAnnouncementAuction = `${urlForAnnouncement}/auction`;
export const urlForAnnouncementBondDebenture = `${urlForAnnouncement}/bond-debenture`;
export const urlForAnnouncementAgmSgm = `${urlForAnnouncement}/agm-sgm`;
export const urlForAnnouncementDividend = `${urlForAnnouncement}/dividend`;

// Rest for Comparitive
const urlForComparitive = `${mainEndpoint}/comparative`;

export const createUrlForComparativeDateWithSecurities = securities => (
    `${urlForComparitive}?${p({ ticker: securities })}`
);
export const createUrlForComparativeDateWithView = viewId => `${urlForComparitive}/view/${viewId}`;
export const createUrlForComparativeView = viewId => `${urlForComparitive}/view/schema/${viewId}`;
export const createParamsForComparativeViewUpdate = ({ token, securities, criteria }) => ({
    method: POST,
    headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({
        securities,
        criteria,
    }),
});

// Rest for Equity Financials
const urlForEquityFinancials = `${mainEndpoint}/tearsheet/financials/retail`;

export const createUrlForEquityFinancialsForTicker = (type, ticker) =>
    `${urlForEquityFinancials}/${type}/${ticker}`;


// Rest for Equity Tearsheet
export const createUrlForEquityTearsheetForTicker = ticker =>
    `${mainEndpoint}/tearsheet/getTearsheetData/${ticker}`;
export const createUrlForEquityPriceActions = ticker =>
    `${mainEndpoint}/tearsheet/priceAction/${ticker}`;

// Rest for Equity key financials
export const createUrlForEquityTearsheetKeyFinancialAndAnnouncementForTicker = ticker =>
    `${mainEndpoint}/tearsheet/keyFinancials/retail/${ticker}`;

// Rest for Equity Dividend History
export const createUrlForEquityDividendHistory = ticker =>
    `${mainEndpoint}/security?${p({ ticker, type: 'div' })}`;

// Rest for Equity Time Series
// https://backendtradingview.systemxlite.com/
// export const TRADINGVIEW_BACKEND_URL = 'https://backendtradingview.systemxlite.com/tearsheetChart';
export const TRADINGVIEW_BACKEND_URL = envVar.REACT_APP_TRADINGVIEW_BACKEND_URL;
// export const TRADINGVIEW_BACKEND_URL = 'http://localhost:3012/tearsheetChart';
export const createUrlFor1DaysSeriesDataForTicker = ({ ticker }) => `${TRADINGVIEW_BACKEND_URL}/stock/${ticker}`;

export const createUrlForEquityTimeSeriesDataForTicker = ({ timeInterval, ticker }) =>
    `${mainEndpoint}/tearsheet/chart/${ticker}/${timeInterval}`;

// Overview
export const urlForOverviewIndicesData = `${mainEndpoint}/marketOverview/nepseIndicesData`;
export const urlForOverviewPriceActions = `${mainEndpoint}/marketOverview/priceActions`;
export const urlForOverviewTopBrokers = `${mainEndpoint}/marketOverview/topBrokers`;
export const urlForOverviewTopLosersGainers = `${mainEndpoint}/marketOverview/topGainerLoser`;
export const urlForOverviewActiveTurnover = `${mainEndpoint}/marketOverview/topVolumeTransaction`;

export const createUrlForOverviewTimeSeriesDataForType = ({ timeInterval, type }) =>
    `${mainEndpoint}/marketOverview/indicesData/${type}/${timeInterval}`;
export const createUrlForOverviewTimeSeriesDataForType1Day = type =>
    `${TRADINGVIEW_BACKEND_URL}/indices/${type}`;
export const createUrlForOverviewSectorDataForType = sector =>
    `${mainEndpoint}/marketOverview/getHeader/${sector}`;

// HomeScreen
export const urlForHomeScreenUpcomingEvents = `${mainEndpoint}/systemxlt/home/upcomingEvents`;
export const urlForHomeScreenTodaysEvents = `${mainEndpoint}/systemxlt/home/todaysEvents`;
export const urlForHomeScreenTodaysAnnouncements = `${mainEndpoint}/systemxlt/home/todaysAnnouncement`;
export const urlForHomeScreenMovers = `${mainEndpoint}/systemxlt/home/movers`;
export const urlForHomeScreenPortfolio = `${mainEndpoint}/systemxlt/home/portfolio`;

export const urlForHomeScreenWatchList = `${mainEndpoint}/systemxlt/home/watchlist`;
export const urlForHomeScreenWatchListTickers = `${mainEndpoint}/systemxlt/home/watchlist/tickers`;
export const urlForHomeScreenWatchListTickersUpdate = `${mainEndpoint}/systemxlt/home/watchlist/add`;

export const createParamsForWatchListTickersUpdate = ({ tickers, token }) => ({
    method: POST,
    headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({
        ticker: [...new Set(tickers)], // unique tickers
    }),
});

function getAuth() {
    if (localStorage.getItem('persist:systemx-lt-') !== undefined && localStorage.getItem('persist:systemx-lt-') !== null) {
        const userid = JSON.stringify({
            userId: JSON.parse(JSON.parse(localStorage.getItem('persist:systemx-lt-')).auth).userId,
            token: JSON.parse(JSON.parse(localStorage.getItem('persist:systemx-lt-')).auth).token,
        });
        console.log(window.btoa(userid).toString());

        return window.btoa(userid).toString();
    }
    return null;
}

// Technical Analysis and Multi chart url

export function getTechnicalAnalysisURL() {
    return `${technicalChartFrontendEndpoint}/systemxlite?tk=${getAuth()}`;
    // return `https://login.systemxlite.com/techChart/systemxlite?tk=${getAuth()}`;
    // return `http://localhost:3001/systemxlite?tk=${getAuth()}`;
}

export function getMultiChartURL() {
    return `${technicalChartFrontendEndpoint}/multiCharts?tk=${getAuth()}`;
}

// export const urlForTechnicalAnalysis = `https://tradingviewsystemxlite.netlify.app/?tk=${getAuth()}`;



// WEBPACK FOOTER //
// ./src/common/rest.js